export enum Label {
  ASSIGNMENT_STARTED = 'Assignment Started',
  GRADE = 'Grade',
  TOTAL_TIME_REPRESENTS = 'Total time represents all the time that the student has spent in the assignment.',
  ASSIGNMENT_SUBMITTED = 'Assignment Submitted',
  TOTAL_TIME_SPENT = 'Total Time Spent',
  CHARTS_COMPLETED = 'Charts Completed',
  CHARTS = 'charts'
}
